import { MapSpecModifiers } from '@platform/maplibre';
import { Buttons, MUIcon } from '@platform/shared/ui';
import { ProjectTypes } from '@platform/types';
import React, { useState } from 'react';
import PanelHeader from '../MapSidebar/PanelHeader';

export interface Props {
  mapObjects: ProjectTypes.MapObject[];
}

const AVAILABLE_MAPS = ['dataviz-light', 'dataviz-dark', 'streets-v2', 'basic-v2'];

const BaseMap: React.FC<Props> = ({ mapObjects }) => {
  const [isPanelVisible, setPanelVisible] = useState<boolean>(false);
  const [primaryMapObj, ...otherMapObjects] = mapObjects;

  const handleChange = (mapId: string) => {
    const updated = MapSpecModifiers.changeBaseMap(primaryMapObj.styleSpec, mapId);
    primaryMapObj.updateMapSpec(updated);

    if (otherMapObjects.length) {
      otherMapObjects.forEach((mapToMirrorUpdate) => {
        mapToMirrorUpdate.updateMapSpec(MapSpecModifiers.changeBaseMap(primaryMapObj.styleSpec, mapId));
      });
    }

    setPanelVisible(false);
  };

  return (
    <>
      <div className="flex flex-col gap-6">
        <div className="px-3 text-sm font-semibold text-gray-800">Base Map</div>
        <div
          className="flex grow cursor-pointer items-center gap-2 rounded-lg border border-gray-300 pr-3 hover:bg-gray-50"
          onClick={() => setPanelVisible(true)}
        >
          <img
            src={`{../../../assets/baseMaps/${primaryMapObj.styleSpec.baseMapId}.png`}
            alt="DataViz Light"
            className="h-[54px] w-[54px] rounded-l-lg"
          />
          <span className="">{primaryMapObj.styleSpec.baseMapId}</span>
          <div className="flex-grow" />
          <Buttons.Link icon={<MUIcon name="edit" className="text-gray-600" />} />
        </div>
      </div>
      {isPanelVisible && (
        <div className="absolute top-0 left-0 right-0 bottom-0 z-50 flex flex-col bg-white">
          <PanelHeader title="Choose Base Map" onBack={() => setPanelVisible(false)} />
          <div className="flex flex-wrap gap-6 overflow-auto p-4">
            {AVAILABLE_MAPS.map((mapId) => (
              <button
                key={mapId}
                onClick={() => handleChange(mapId)}
                className="h-32 w-1/2 cursor-pointer border bg-cover bg-center"
                style={{ backgroundImage: `url(./../../assets/baseMaps/${mapId}.png)` }}
              >
                <span className="m-1 bg-white p-2 text-sm">{mapId}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default BaseMap;
